define([
    'common/domain/action/index',
    'notify/domain/entity/notification',
    'notify/domain/factory/notification',
    'notify/domain/collection/notification',
    'common/domain/repository/dispatcher',
    'backbone'
], function(
    Actions,
    NotificationModel,
    NotificationFactory,
    NotificationCollection,
    Dispatcher,
    Backbone
    ) {
    var ReviewStore = Backbone.Model.extend({
        initialize: function() {
            _.bindAll(this, 'dispatch');
            this._reviews = new NotificationCollection();
            Dispatcher.register(this.dispatch);
        },

        clearAll: function() {
            this._reviews = new NotificationCollection();
        },

        getReviews: function() {
            return this._reviews;
        },

        dispatch: function(action) {
            switch(action.type) {
                case Actions.CREATE_REVIEW:
                    this._createReview(action);
                    break;
                case Actions.READ_REVIEW:
                    this._readReview(action);
                    break;
            }
        },

        _createReview: function(action) {
            var _reviews = this._reviews;
            if(!action.review) {
                return;
            }

            if(!_.isArray(action.review)){
                action.review = [action.review]
            }

            const reviews = _.map(action.review, function(j) {
                if(j.version == 2 || j.version == 3) {
                    return NotificationFactory.build(j.type, j);
                }
                return new NotificationModel(j);
            });

            // fetch されたならパフォーマンスのために reset のみ飛ばす
            if(action.options && action.options.fetched) {
                if (action.options.fetchMore && reviews.length == 0) {
                    _reviews.trigger('noMore');
                } else {
                    _reviews.add(reviews, {merge: true, silent: true});
                    _reviews.trigger('reset');
                    _reviews.trigger('fetch');
                }
            } else {
                _reviews.add(reviews, {merge: true});
            }
        },

        _readReview: function(action) {
            var _reviews = this._reviews;
            if(!action.review) {
                return;
            }

            var reviews = _.isArray(action.review) ? action.review : [action.review];
            _.each(reviews, function(j) {
                var review = _reviews.get(j.id);
                if(review) {
                    review.set({read: action.read});
                }
            });
        }
    });

    return new ReviewStore();
});



// WEBPACK FOOTER //
// ./notify/domain/repository/review.js